import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import css from './SemiFinishedAddSemiFinishedModal.module.css';
import { semiFinishedActions, semiFinishedSemiFinishedActions } from "../../../../store/slices/semiFinished-slice";

const SemiFinishedUpdateSemiFinishedModal = ({
    semiFinishedId,
    setUpdateOpen,
    weight,
    weightNetto,
}) => {
    const [selectedItem, setSelectedItem] = useState(null);
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const { semiFinishedArray, trigger } = useSelector(store => store.semiFinished);
    const { semiFinishedSemiFinishedForModalArray } = useSelector(store => store.semiFinishedSemiFinished);

    const [localWeight, setLocalWeight] = useState(weight);
    const [localWeightNetto, setLocalWeightNetto] = useState(weightNetto);

    useEffect(() => {
        dispatch(semiFinishedActions.getAllSemiFinished());
    }, [trigger, dispatch]);

    useEffect(() => {
        if (semiFinishedArray.length > 0 && semiFinishedId) {
            setSelectedItem(semiFinishedArray.find(obj => obj.id === semiFinishedId));
        }
    }, [semiFinishedArray, semiFinishedId]);

    const handleUpdateSubmit = async (e, data) => {
        e.preventDefault();
        try {
            if (!selectedItem) return;

            const newWeightNetto = Number(data.weightNetto);

            let newWeight;
            if (data.weight && Number(data.weight) > 0) {
                newWeight = Number(data.weight);
            } else {
                const originalWeight = parseFloat(selectedItem.weight) || 0;
                const originalWeightNetto = parseFloat(selectedItem.weightNetto) || 0;
                const nettoRatio = originalWeight > 0 ? originalWeightNetto / originalWeight : 1;
                newWeight = nettoRatio > 0 ? Number((newWeightNetto / nettoRatio).toFixed(2)) : newWeightNetto;
            }

            const originalItemWeight = parseFloat(selectedItem.weight) || 100;
            const portionMultiplier = newWeight / originalItemWeight;

            const totalProductsCost = (selectedItem.products || []).reduce(
                (sum, p) => sum + (parseFloat(p.cost) || 0),
                0
            );
            const totalChildSfCost = (selectedItem.includedSemiFinisheds || []).reduce(
                (sum, s) => sum + (parseFloat(s.cost) || 0),
                0
            );
            let totalSemiFinishedCost = totalProductsCost + totalChildSfCost;
            if (totalSemiFinishedCost === 0) {
                totalSemiFinishedCost = parseFloat(selectedItem.cost) || 0;
            }

            const updatedItem = {
                id: selectedItem.id,
                name: selectedItem.name,
                weight: newWeight,
                weightNetto: newWeightNetto,
                cost: Number((totalSemiFinishedCost * portionMultiplier).toFixed(2)),
                energy: Number(((selectedItem.energy || 0) * portionMultiplier).toFixed(2)),
                fats: Number(((selectedItem.fats || 0) * portionMultiplier).toFixed(2)),
                proteins: Number(((selectedItem.proteins || 0) * portionMultiplier).toFixed(2)),
                carbohydrates: Number(((selectedItem.carbs || 0) * portionMultiplier).toFixed(2)),
            };

            const updatedArray = semiFinishedSemiFinishedForModalArray.map(item => {
                if (
                    item.semiFinishedId === semiFinishedId ||
                    item.childId === semiFinishedId ||
                    item.id === semiFinishedId
                ) {
                    return updatedItem;
                }
                return item;
            });

            dispatch(semiFinishedSemiFinishedActions.updateSemiFinishedSemiFinishedForModal(updatedArray));
            dispatch(semiFinishedSemiFinishedActions.changeTrigger());
            setUpdateOpen(false);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <section className={css.overlay}>
            <div className={css.modal}>
                <button
                    className={css.closeButton}
                    onClick={() => setUpdateOpen(false)}
                >
                    &times;
                </button>
                <h2 className={css.title}>Update Semi-Finished</h2>

                <form className={css.content}>
                    <div className={css.inputGroup}>
                        <label>{t('Semi-Finished')}</label>
                        <h2>
                            {selectedItem?.name[currentLanguage] ||
                                selectedItem?.name?.['en']}
                        </h2>
                    </div>

                    <div className={css.inputGroup}>
                        <label htmlFor="weight">{t('Weight')}</label>
                        <input
                            type="number"
                            id="weight"
                            value={localWeight}
                            onChange={(e) => setLocalWeight(e.target.value)}
                        />
                    </div>

                    <div className={css.inputGroup}>
                        <label htmlFor="weightNetto">{t('WeightNetto')}</label>
                        <input
                            type="number"
                            id="weightNetto"
                            value={localWeightNetto}
                            onChange={(e) => setLocalWeightNetto(e.target.value)}
                        />
                    </div>

                    <div className={css.actions}>
                        <button
                            type="button"
                            className={css.cancelButton}
                            onClick={() => setUpdateOpen(false)}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={css.okButton}
                            onClick={(e) =>
                                handleUpdateSubmit(e, {
                                    weight: localWeight,
                                    weightNetto: localWeightNetto,
                                })
                            }
                        >
                            OK
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
};

export { SemiFinishedUpdateSemiFinishedModal };
